import React from "react";
import { useSelector } from "react-redux";
import LiveTrack from "./LiveTrack";
import NexusLiveTrack from "./NexusLiveTrack";

// Accounts linked to a TraKing company (MASTERCOMP.NexusCompId) get live data
// from TraKing; every other account keeps the existing Live Tracking page.
const LiveTrackSwitch = () => {
  // MCID 59 (the Nexus operator) keeps the standard Live Tracking for now
  const usesTraking = useSelector((state) => {
    const u = state?.authTracking?.userInfo;
    return Boolean(u?.NexusCompId) && Number(u?.MCID) !== 59;
  });
  return usesTraking ? <NexusLiveTrack /> : <LiveTrack />;
};

export default LiveTrackSwitch;
